import type { dash } from "@dropbox/api-v2-client";
import type {
  AuthorInfo,
  BrandedSiteInfo,
  ConnectorInfo,
  FileTypeInfo,
  ItemLocation,
  Modifier,
} from "@mirage/shared/search/search-result";
import type { BrowserViewMap } from "./scoring/browser-views";
import type { ClickMap } from "./scoring/clicks";

// internal mirage type analogous to dash_typeahead.Recommendation
export type Recommendation<T extends "omnibox" | "typeahead" = "typeahead"> = {
  uuid: string;
  title: string;
  url: string | null;
  recordType: dash.RecordType;
  connectorInfo: ConnectorInfo;
  fileTypeInfo?: FileTypeInfo | null;
  brandedSiteInfo?: BrandedSiteInfo | null;
  lastClickedMs: number | null;
  clicks: ClickMap | null;
  lastBrowserViewMs: number | null;
  browserViewsHistory: BrowserViewMap | null;
  parent?: ItemLocation | null;
  sender?: AuthorInfo | null;
  creator?: AuthorInfo | null;
  lastModifier?: AuthorInfo | null;
  filteredModifier?: Modifier | null;
  providerUpdateAtMs?: number;
  summarizable?: dash.SummarizableType[".tag"] | null;
  virtualPath?: string[];
  previewUrl?: string | null;

  // common data model:
  // https://www.dropbox.com/scl/fi/4ygg2u34sva85derzsmnl/Common-Data-Model-for-Connector.paper?rlkey=7jkfrw787k9xmhtm9x4pv96zi&dl=0
  mimeType?: string | null;
  status?: string | null;
  priority?: string | null;
  category?: string | null;
  assignedTo?: AuthorInfo | null;
  tags?: dash.Tag[];
  referenceId?: string | null; // ex. JIRA ticket number
  logicalType?: string | null;
  typeaheadRecommendationRequestId?: string | null;
} & (T extends "omnibox"
  ? {
      score: number;
      predictionId: string;
    }
  : // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    {});

export const isOmniboxRecommendation = (
  rec: Recommendation,
): rec is Recommendation<"omnibox"> => {
  return "predictionId" in rec;
};
